import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';

@Component({
	selector: 'app-storefront-layout',
	templateUrl: './storefront-layout.component.html',
	styleUrls: ['./storefront-layout.component.scss']
})
export class StorefrontLayoutComponent {
	color = 'blue';

	constructor(
		private location: Location,
		private globalSearchService: GlobalSearchService
	) {
		this.color = this.globalSearchService.getColor();
	}

	back(): void {
		this.location.back();
	}
}
